import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/icons/profile.svg'


const _hoisted_1 = { class: "header-secondary__sidebar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-left",
  style: {"cursor":"pointer"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "header-secondary__main" }
const _hoisted_6 = {
  key: 0,
  class: "header-secondary__menu"
}
const _hoisted_7 = { class: "header-secondary__icons" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "header__profile",
  src: _imports_1,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SearchHeader = _resolveComponent("SearchHeader")!
  const _component_ButtonLanguage = _resolveComponent("ButtonLanguage")!
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_ButtonLogin = _resolveComponent("ButtonLogin")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-secondary", {'is-compact': _ctx.isCompact}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_RouterLink, {
          to: "/",
          onClick: _ctx.handleLogoClick,
          class: _normalizeClass({'desktop-only': _ctx.currentRoute === 'tenderPage'})
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick", "class"]),
        (_ctx.currentRoute === 'tenderPage')
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              class: "go-back-mobile mobile-only"
            }, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_SearchHeader, { "is-secondary": true }),
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_RouterLink, {
                to: { path: '/templates', query: { page: '1' } },
                class: _normalizeClass({ 'is-selected': _ctx.currentRoute === 'templates' }),
                onClick: _ctx.trackHeaderTemplates
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("header.templates")), 1)
                ]),
                _: 1
              }, 8, ["class", "onClick"]),
              _createVNode(_component_RouterLink, {
                to: { path: '/favourites', query: { page: '1' } },
                class: _normalizeClass({ 'is-selected': _ctx.currentRoute === 'favourites' }),
                onClick: _ctx.trackHeaderFavourites
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("header.favourites")), 1)
                ]),
                _: 1
              }, 8, ["class", "onClick"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ButtonLanguage),
          _createTextVNode("ButtonLanguage "),
          _createVNode(_component_LanguageDropdown, { show: _ctx.showLanguageDropdown }, null, 8, ["show"]),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_ButtonLogin, { key: 0 }))
            : (_openBlock(), _createBlock(_component_RouterLink, {
                key: 1,
                to: "/profile"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }))
        ])
      ])
    ], 2)
  ]))
}